import { WhyChooseTechItemTypes } from "../../../utility/types/generaTypes";
import GradientIcon from "../gradientIcon/GradientIcon";
import "./WhyChooseTechCard.css";

type WhyChooseTechCardProps = {
  whyChooseTech: WhyChooseTechItemTypes;
};
const WhyChooseTechCard = ({ whyChooseTech }: WhyChooseTechCardProps) => {
  return (
    <div className="whyChooseTechCard_container">
      <div className="whyChooseTechCard_header_container">
        <GradientIcon
          src={whyChooseTech?.icon}
          alt={whyChooseTech?.title + "_icon"}
          mainContainerClassName={"whyChooseTechCard_img_container"}
        />
        <p className="whyChooseTech_title">{whyChooseTech?.title}</p>
      </div>
      <p className="whyChooseTech_description">{whyChooseTech?.description}</p>
    </div>
  );
};

export default WhyChooseTechCard;
